import axios from '@/utils/axios'

export default {
  getTraits() {
    return axios.get('/xhr/segment/traits')
  },
}
